import { useForm } from "react-hook-form";
import apiAdmin from "../../services/api-admin";

function ReconveyanceCancelModal({ show, reconveyanceOrderId, setShowCancelModal, setCancelReconveyanceOrderId, setSubmitted })
    {
    const { register, handleSubmit, reset } = useForm();
    const onSubmit = async (data) => {

        await apiAdmin.post("/cancel-reconveyance-order", {
            reconveyanceOrderId,
            cancellationReason: data.cancellationReason
        });

        setSubmitted(prev => !prev);
        setCancelReconveyanceOrderId(null);
        setShowCancelModal(false);
        reset();
    };

    if (!show) return null;

    return (
        <>
            <div className="modal fade show d-block">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Cancel Order #{reconveyanceOrderId}
                                </h5>
                            </div>
                            <div className="modal-body">
                                <label className="form-label">
                                    Reason for Cancellation
                                </label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    {...register("cancellationReason", {
                                        required: true
                                    })}
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowCancelModal(false)}>Close</button>
                                <button type="submit" className="btn btn-danger">Cancel Order</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}

export default ReconveyanceCancelModal;


